module.exports = __webpack_public_path__ + "img/icon-cross.0b8b76e6.svg";